import React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  IconButton,
  Checkbox,
  Typography,
  Box,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Task } from '../types';

interface TaskListProps {
  tasks: Task[];
  onDeleteTask: (taskId: string) => void;
  onUpdateTask: (task: Task) => void;
}

const TaskList: React.FC<TaskListProps> = ({
  tasks,
  onDeleteTask,
  onUpdateTask,
}) => {
  const handleToggleComplete = (task: Task) => {
    onUpdateTask({
      ...task,
      completed: !task.completed,
    });
  };

  return (
    <List>
      {tasks.map((task) => (
        <ListItem
          key={task.id}
          secondaryAction={
            <IconButton
              edge="end"
              aria-label="delete"
              onClick={() => onDeleteTask(task.id)}
            >
              <DeleteIcon />
            </IconButton>
          }
        >
          <Checkbox
            edge="start"
            checked={task.completed}
            onChange={() => handleToggleComplete(task)}
          />
          <ListItemText
            primary={
              <Typography
                sx={{
                  textDecoration: task.completed ? 'line-through' : 'none',
                }}
              >
                {task.title}
              </Typography>
            }
            secondary={
              <Box component="span">
                <Typography component="span" variant="body2" color="text.secondary" display="block">
                  {task.description}
                </Typography>
                <Typography component="span" variant="caption" color="text.secondary" display="block">
                  Created: {task.createdAt.toLocaleDateString()}
                </Typography>
              </Box>
            }
          />
        </ListItem>
      ))}
      {tasks.length === 0 && (
        <ListItem>
          <ListItemText
            primary={
              <Typography color="text.secondary" align="center">
                No tasks in this quadrant
              </Typography>
            }
          />
        </ListItem>
      )}
    </List>
  );
};

export default TaskList; 